"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SlidePage = exports.ContentPages = exports.ContentToggleWrapper = void 0;
/* A component for i.e. mobile menu that allows the user to navigate between step A and B */
var React = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var margin_1 = __importDefault(require("../Utils/margin"));
var padding_1 = __importDefault(require("../Utils/padding"));
var useMutationObserver_1 = __importDefault(require("../Hooks/useMutationObserver"));
exports.ContentToggleWrapper = styled_components_1.default.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  ", "\n  ", "\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"], ["\n  ", "\n  ", "\n  overflow: hidden;\n  height: 100%;\n  width: 100%;\n"])), margin_1.default, padding_1.default);
exports.ContentPages = styled_components_1.default.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  align-items: start;\n  display: flex;\n  flex-wrap: nowrap;\n  width: 200%;\n  ", "\n"], ["\n  align-items: start;\n  display: flex;\n  flex-wrap: nowrap;\n  width: 200%;\n  ", "\n"])), function (props) { return "\n    height: ".concat(props.$height, "px;\n    margin-left: ").concat(props.$toggle ? '-100%' : '0%', ";\n    transition: all ").concat(props.$speed / 1000, "s ease-in-out;\n  "); });
exports.SlidePage = styled_components_1.default.div(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  width: 50%;\n"], ["\n  width: 50%;\n"])));
var ContentToggle = function (_a) {
    var children = _a.children, _b = _a.speed, speed = _b === void 0 ? 250 : _b, props = __rest(_a, ["children", "speed"]);
    var firstPage = React.useRef(null);
    var secondPage = React.useRef(null);
    var _c = React.useState(), page = _c[0], setPage = _c[1];
    var _d = React.useState(false), toggle = _d[0], setToggle = _d[1];
    var _e = React.useState(0), menuHeight = _e[0], setMenuHeight = _e[1];
    var firstPageMutation = (0, useMutationObserver_1.default)(firstPage);
    var secondPageMutation = (0, useMutationObserver_1.default)(secondPage);
    var updateHeight = React.useCallback(function () {
        var currentPage = toggle ? secondPage.current : firstPage.current;
        if (currentPage) {
            setMenuHeight(currentPage.offsetHeight);
        }
    }, [toggle]);
    React.useEffect(function () {
        updateHeight();
    }, [toggle, updateHeight]);
    React.useEffect(function () {
        updateHeight();
    }, [firstPageMutation, secondPageMutation, updateHeight]);
    var toggleNext = function (next) {
        setPage(next);
        setToggle(true);
    };
    var toggleBack = function () {
        setToggle(false);
    };
    return (React.createElement(exports.ContentToggleWrapper, __assign({}, props),
        React.createElement(exports.ContentPages, { "$toggle": toggle, "$speed": speed, "$height": menuHeight },
            React.createElement(exports.SlidePage, { ref: firstPage }, children(toggleBack, toggleNext)),
            React.createElement(exports.SlidePage, { ref: secondPage }, page))));
};
exports.default = ContentToggle;
var templateObject_1, templateObject_2, templateObject_3;
